<template>
  <span
    :class="`${
      isCursorPointer ? 'tw-w-[180px] tw-cursor-pointer' : 'tw-w-[180px]'
    }`"
  >
    <div class="tw-items-center tw-inline-flex">
      <div
        v-if="value"
        :class="`${status[value]?.className} ${classCurrentUser}`"
        class="cell-status tw-flex tw-items-center"
        @click="updateStatus(value)"
      >
        <span v-if="statusNumber" class="tw-mr-[3px]">{{
          props.statusNumber
        }}</span>
        <span
          :class="`tw-max-w-[115px] tw-truncate ${lableClass}`"
          data-cy="vendor-checklist-requested-status"
          >{{ label ?? status[value]?.label }}</span
        >
      </div>
    </div>
  </span>
</template>

<script lang="ts" setup>
import store from "@/store";
import {
  checklistRequestedStatusId,
  checklistStatusId,
  statusCode,
} from "@/utils/constants";
import utilities from "@/utils/utilities";
import { computed } from "vue";

const props = defineProps({
  value: { type: String, required: true },
  isCursorPointer: { type: Boolean, default: false, required: false },
  statusNumber: { type: Number, default: () => 0 },
  label: { type: String, default: () => null },
  lableClass: { type: String, default: () => "" },
  isCheckPlan: { type: Boolean, default: false },
  classCurrentUser: { type: String, default: "" },
});
const color = computed(() => (props.isCheckPlan ? "#904bd6" : "#878787"));
const borderColor = computed(() => (props.isCheckPlan ? "#eee4f9" : "#eff0f1"));
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const emit = defineEmits(["update:status"]);

const updateStatus = (value) =>
  value == statusCode.pending ||
  (checklistStatusId.created && emit("update:status", value));
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const status = {};

status[checklistRequestedStatusId.created] = {
  label: getUiText(
    "app-component-assessments-checklists-requested-status-created-1",
  ),
  className: "created",
};
status[checklistStatusId.inProgress] = {
  label: getUiText(
    "app-component-assessments-checklist-requested-status-inprogress-1",
  ),
  className: "inProgress",
};
status[checklistStatusId.waiting] = {
  label: getUiText(
    "app-component-vendor-input-checklist-requested-status-waiting-1",
  ),
  className: "inProgress",
};
status[checklistStatusId.submitted] = {
  label: getUiText(
    "app-component-status-badge-vendor-assessment-submitted-status-1",
  ),
  className: "submitted",
};
status[checklistStatusId.completed] = {
  label: getUiText(
    "app-component-assessments-checklists-requested-status-completed-1",
  ),
  className: "complete",
};
</script>

<style scoped lang="scss">
.cell-status {
  padding: 3px 5px;
  height: 20px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.inProgress {
  background: linear-gradient(
      0deg,
      rgba(72, 160, 255, 0.15) 0%,
      rgba(72, 160, 255, 0.15) 100%
    ),
    #fff;
  color: #387dff;
}

.created {
  background: var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.complete {
  background: var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.onHold {
  background: #fff0da;
  color: #fe9a05;
}

.submitted {
  color: var(--placeholder-purple, #904bd6);
  background: rgba(144, 75, 214, 0.1);
}
</style>
